import { toast } from "react-toastify";
import LedgersRepository from "../../Repository/LedgersRepository";
import { clearLedgers } from "./ledgerSlice";
import { v4 as uuidv4 } from "uuid";
import { Toast } from "../components/Toast";
import { loadGoogleAnalytics } from "../../pages/analytics/analytics";

export const searchLedger = async (text) => {
  try {
    let { data } = await LedgersRepository.ledgerModel({
      request: {
        method: "searchLedgersByCompany",
        data: {
          company_code: localStorage.getItem("companyCode"),
          ledgerName: text,
        },
      },
    });
    if (data.response.status.statusCode == 200) {
      return data.response.data.ledgers;
    } else {
      toast.configure();
      toast.error("Error");
    }
  } catch (err) {
    toast.configure();
    toast.error("Error");
  }
};
export const getLedger = async (id) => {
  try {
    let { data } = await LedgersRepository.ledgerModel({
      request: {
        method: "getLedger",
        data: {
          _id: id,
        },
      },
    });

    if (data.response.status.statusCode == 200) {
      return data.response.data.ledger;
    } else {
      toast.configure();
      toast.error("Error");
    }
  } catch (err) {
    toast.configure();
    toast.error("Error");
  }
};
export const saveLedger = async (new_ledger, dispatch,status="") => {
  console.log("ledd", new_ledger);
  console.log("dis", dispatch);
  console.log("statusss", status);
  const trackingId = "G-9JX2HR95FS";


  try {
    let { data } = await LedgersRepository.ledgerModel({
      request: {
        method: "saveLedger",
        data: {
          ledger: {
            _id: new_ledger?._id,
            name: new_ledger.name,
            company_code: localStorage.getItem("companyCode"),
            ledgerType: new_ledger.ledgerType,
            address: new_ledger.address,
            phoneNo:new_ledger.phoneNo,
            region: new_ledger.region ? new_ledger.region : "",
          },
        },
      },
    });
    if (data.response.status.statusCode == 200) {
      toast.configure();
      toast.success("Ledger Created");
      // loadGoogleAnalytics(trackingId);
      // if (status?.trim().toLowerCase() == "paid" && typeof gtag === "function") {
      //   gtag("event", "save_ledger", {
      //     event_category: "Ledger Management",
      //     event_label: new_ledger.name || "Unnamed Ledger",
      //     value: status === "paid" ? 1 : 0, // Optional: Adjust value logic if needed
      //   });
      //   console.log("Google Analytics: Ledger creation event sent");
      // }

      return data;
    } else {
      toast.configure();
      toast.info("Ledger Not Created");
      dispatch(clearLedgers());
    }
  } catch (err) {
    dispatch(clearLedgers());
    toast.configure();
    toast.info("Error");
  }
};
export const createLedger = async (_id, new_ledger, dispatch) => {
  try {
    return LedgersRepository.ledgerModel({
      request: {
        method: "saveLedger",
        data: {
          ledger: {
            _id: _id,
            name: new_ledger.name,
            company_code: localStorage.getItem("companyCode"),
            ledgerType: new_ledger.ledger_type,
            address: new_ledger.address,
            region: new_ledger?.region || "",
          },
        },
      },
    });
  } catch (err) {
    toast.configure();
    toast.info("Ledger Not Created");
    dispatch(clearLedgers());
  }
};
export const updateSaleLedger = (_id = "", bill, paid, total,totalValue,clearBalance) => {
  console.log("bill", bill)
  console.log("paid", paid)
  console.log("total", total)
  console.log("totalvalue", totalValue)


  let amount = 0;
  let remaining = 0;
  // if (paid > total) {
  //   amount = total;
  // } else {
    amount = paid;
    // remaining = parseFloat(clearBalance ? totalValue - paid : total - paid );
    remaining = parseFloat( total - paid )
  // }

  if(amount > total ) {
    paid = total
   }

   if(amount > total && !clearBalance) {
    remaining = 0
   }

  let srNum = uuidv4();
  try {
    return LedgersRepository.ledgerModel({
      request: {
        method: "updateSaleLedger",
        data: {
          _id: _id,
          sale: {
            srNum: srNum,
            date: +new Date(),
            detail: `Item Sale ${bill}`,
            billNumber: bill,
            totalAmount: Number(total),
            depositedAmount: paid ? Number(paid) : 0,
            remainingAmount: remaining ? Number(remaining ): 0,
            isReturn: false,
          },
        },
      },
    });
  } catch (err) {
    console.log(err);
  }
};




export const createLedgerEntryNew = (id, balance,formallyOutstandings) => {
  let srnums = uuidv4();
  let date = +new Date();
  return LedgersRepository.ledgerModel({
    request: {
      method: "updateSaleLedger",
      data: {
        _id: id,
        sale: {
          srNum: srnums,
          date: date,
          detail: "Balance Cleared",
          totalAmount:formallyOutstandings ? formallyOutstandings  :( balance ? balance : 0 ),
    
          depositedAmount: balance ? balance : 0,
          // remainingAmount: balance ? 0 - balance : 0,
          remainingAmount: (formallyOutstandings > balance ? -(formallyOutstandings - balance) : -(formallyOutstandings)),
        },
      },
    },
  });
};

export const removeLedger = async (ledger, dispatch, index) => {
  try {
    let { data } = await LedgersRepository.ledgerModel({
      request: {
        method: "deleteLedger",
        data: {
          _id: ledger._id,
        },
      },
    });
    if (data.response.data.ledger) {
      toast.configure();
      toast.success("Ledger Deleted successfully");
    } else {
      toast.configure();
      toast.error("Ledger Not Deleted");
      dispatch(clearLedgers());
    }
  } catch (err) {
    console.log(err);
  }
};
export const updateLedger = async (ledger) => {
  try {
    let { data } = await LedgersRepository.ledgerModel({
      request: {
        method: "updateLedgerGeneral",
        data: {
          _id: ledger._id,
          _rev: ledger._rev,
          name: ledger.name,
          address: ledger.address,
          region: ledger.region,
        },
      },
    });
    if (data.response.data.ledger) {
      toast.configure();
      toast.success("Ledger Updated successfully");
    } else {
      toast.configure();
      toast.error("Ledger Not Updated");
    }
  } catch (err) {
    toast.configure();
    toast.error("Error");
    console.log(err);
  }
};
export const deleteEntry = async (id, sr, type, history) => {
  try {
    let { data } = await LedgersRepository.ledgerModel({
      request: {
        method: "deleteLedgerEntry",
        data: {
          _id: id,
          srNum: sr,
          ledgerType: type,
        },
      },
    });
    if ((data.response.status.statusCode = 200)) {
      toast.configure();
      toast.success("Entry Deleted successfully");
    } else {
      toast.configure();
      toast.error("Entry Not Deleted");
      history.push("/inventory/admin/ledgers");
    }
  } catch (err) {
    console.log(err);
    history.push("/inventory/admin/ledgers");
  }
};
export const updateEntryDetails = async (state, sr, type, history) => {
  console.log('state',state)
  try {
    let { data } = await LedgersRepository.ledgerModel({
      request: {
        method: "updateLedgerEntry",
        data: {
          company_code: localStorage.getItem("companyCode") ,
          ledgerId: state.ledgerId,
          ledgerType: type,
          srNum: state.srNum,
          updatedLedgerEntry: {
            detail: state.detail,
            totalAmount: Number(state.totalAmount || 0),
            depositedAmount: Number(state.depositedAmount),
            remainingAmount: Number(state.totalAmount -  state.depositedAmount) ,
          },
        },
      },
    });
    if (data.response.data.ledgerId) {
      Toast("success", "Ledger Entry Updated");
    } 
  } catch (err) {
    console.log(err);
    Toast("error", "Error");
    history.push("/inventory/admin/ledgers");
  }
};
export const updateEntry = async (copy, sr, type, history) => {
  console.log('cooooppy', copy)
  try {
    let { data } = await LedgersRepository.ledgerModel({
      request: {
        method: "updateLedger",
        data: {
          ledger: {
            ...copy,
            changedSrNumber: sr,
            changedLedgerType: type,
          },
        },
      },
    });
    if (data.response.data.ledger) {
      Toast("success", "Ledger Entry Updated");
    } else {
      Toast("error", "Ledger Entry Not Update");
      history.push("/inventory/admin/ledgers");
    }
  } catch (err) {
    console.log(err);
    Toast("error", "Error");
    history.push("/inventory/admin/ledgers");
  }
};
export const createLedgerEntry = (id, balance,formallyOutstandings) => {
  let srnums = uuidv4();
  let date = +new Date();
  return LedgersRepository.ledgerModel({
    request: {
      method: "updateSaleLedger",
      data: {
        _id: id,
        sale: {
          srNum: srnums,
          date: date,
          detail: "Balance Cleared",
          totalAmount:formallyOutstandings ? formallyOutstandings  :( balance ? balance : 0 ),
    
          depositedAmount: balance ? balance : 0,
          // remainingAmount: balance ? 0 - balance : 0,
          remainingAmount: (formallyOutstandings > balance ? -(formallyOutstandings - balance) : -(formallyOutstandings)),
        },
      },
    },
  });
};
export const fetchLedger = async (idval, type) => {
  let total = 0;
  let pending = 0;
  let returnAmount = 0;
  let { data } = await LedgersRepository.ledgerModel({
    request: {
      method: type,
      data: {
        _id: idval,
      },
    },
  });
  let ledger =
    type === "getPurchaseLedgersById"
      ? data.response.data.purchaseLedgers
      : data.response.data.saleLedgers;

  ledger?.forEach((ledgerItem, idx) => {
    if (
      ledgerItem?.detail.startsWith("Purchase Returned") ||
      ledgerItem?.detail.startsWith("Sale Return") ||
      ledgerItem?.detail.startsWith("Returned Bill")
    ) {
      returnAmount += parseInt(ledgerItem?.totalAmount);
    } else {
      total += parseInt(ledgerItem?.totalAmount);
    }
    if (idx === 0) {
      pending = parseInt(ledgerItem?.balance);
    }
  });

  return { totalAmount: total - returnAmount, ledger, pending ,dataLedger:data?.response?.data};
};
export const updateOldLedger = async (ledger) => {
  let { data } = await LedgersRepository.ledgerModel({
    request: {
      method: "updateLedgerGeneral",
      data: {
        _id: ledger._id,
        _rev: ledger._rev,
        ledgerType: ledger.ledgerType,
      },
    },
  });
  if (data.response.status.statusCode == 200) {
    toast.configure();
    toast.success("Updated Successfully");
  } else {
    toast.configure();
    toast.error("Not Updated");
  }
};
